import { IButtonComponentProps, IIconButtonComponentProps } from '@moosend/mooskin';
import { ISegmentCriteria } from '../mailingLists/model';

export interface IConditionButton extends IIconButtonComponentProps {
	onButtonClick?: (id: string, extraOption: string) => void;
}

export interface IConditionQueryField {
	Comparers: { [key: string]: string };
	IsCampaignFilterSupported: boolean;
	IsCrossMailingListField: boolean;
	IsDateFunctionSupported: boolean;
	IsDateRangeField: boolean;
	IsProductFilterSupported: boolean;
	IsBrandFilterSupported: boolean;
	IsCategoryFilterSupported: boolean;
	IsTimesFilterSupported: boolean;
	IsWebsiteFilterSupported: boolean;
	Key: string;
	Name: string;
	OtherMailingListId: string;
	Type: FieldType;
	CriteriaType: number;
	Options: IConditionSuggestion[];
	IsDisabled: boolean;
	MinAllowedDate?: string;
}

export interface IFieldOptions {
	IsCampaignFilterSupported?: boolean;
	IsCrossMailingListField?: boolean;
	IsDateFunctionSupported?: boolean;
	IsDateRangeField?: boolean;
	IsProductFilterSupported?: boolean;
	IsTimesFilterSupported?: boolean;
	IsWebsiteFilterSupported?: boolean;
	IsDisabled?: boolean;
	IsBrandFilterSupported: boolean;
	IsCategoryFilterSupported: boolean;
	MinAllowedDate?: string;
}

export interface IConditionFilter {
	id: string;
	criteria: string;
	customField?: ISegmentCriteria['CustomField'];
	criteriaType: number;
	comparer: string;
	value: any;
	valueType: FieldType;
	suggestions: IConditionSuggestion[];
	extraOption: '' | 'dateBetween' | 'interval';
	dateBetween: {
		EndDate: string; // upper case because backend
		StartDate: string; // upper case because backend
	};
	interval: {
		value: number;
		type: number;
	};
	comparerOptions: IFilterSelectOptions[];
	buttons?: IConditionButton[];
	loading?: boolean;
	fieldOptions?: IFieldOptions;
	dateFunction?: string;
}

export interface IConditionPayload {
	id: string;
	entityId?: string;
	queryField: string;
	queryFieldValue: any;
	comparer: string;
	criteriaType: number;
	lastXMinutes?: number | null;
	frequencyType?: number;
	dateBetween: { EndDate: string; StartDate: string } | null; // upper case because backend
}

export interface IFilterSelectOptions {
	value: string;
	label: string;
}

export interface IConditionSuggestion {
	Key?: any;
	Value: any;
	Label?: string;
}

export type FieldType =
	| 'DateTimeWithPrecision'
	| 'DateTime'
	| 'Date'
	| 'Text'
	| 'Integer'
	| 'Decimal'
	| 'Guid'
	| 'Enum'
	| 'Boolean'
	| 'DropDown';

export interface IWebsites {
	Id: string;
	Domain: string;
}
